import { z } from 'zod';
import { ReactionType, EngagementCounts } from './engagement.js';
/**
 * Reaction contract (FR-ENGA-01, AC-ENGA-01).
 *
 * Semantics: one reaction per member per object. Sending a different type
 * replaces the previous one; sending the SAME type again removes it (toggle).
 * The response carries the authoritative counts so optimistic UIs reconcile
 * against it (AC-ENGA-01.3).
 */
export const SetReactionInput = z.object({ type: ReactionType });
export const ReactionState = z.object({
    contentId: z.string(),
    /** The caller's reaction after this operation; null after a toggle-off. */
    myReaction: ReactionType.nullable(),
    engagement: EngagementCounts,
});
/** The caller's own state on a page of content — one batched call (docs/03 §0.4). */
export const ViewerContentState = z.object({
    contentId: z.string(),
    myReaction: ReactionType.nullable(),
    favourited: z.boolean(),
});
//# sourceMappingURL=engagement-routes.js.map